import FlatPriceEditor from "./FlatPriceEditor";

export default FlatPriceEditor;



// WEBPACK FOOTER //
// ./src/components/Pricebook/FlatPriceEditor/index.js